import React from 'react';
import LegacyButton from '../LegacyButton';
import LegacyPortalDialog from '../LegacyPortalDialog';

export type LegacyInputTextDialogProps = {
  [key: string]: any;
  callback?: (result: number) => void;
  style?: any;
  title?: any;
  value?: any;
  applyAll?: any;
  okText?: any;
};

const LegacyInputTextDialog = (props: LegacyInputTextDialogProps) => {
  const result = (value: number) => props.callback && props.callback(value);

  return (
    <LegacyPortalDialog result={result} style={props.style}>
      <span className="ha-dialog-title">{props.title}</span>
      <textarea value={props.value}></textarea>
      <div className="horizontal justified">
        {props.applyAll && (
          <LegacyButton size="small" className="li-done-all" onClick={() => result(1)}>
            {props.applyAll}
          </LegacyButton>
        )}
        <LegacyButton size="small" className="ha-dialog-done" onClick={() => result(2)}>
          {props.okText || 'OK'}
        </LegacyButton>
      </div>
    </LegacyPortalDialog>
  );
};

export default LegacyInputTextDialog;
